export default "__VITE_ASSET__Dp9g9Zmv__"